import { useAppSelector } from "@/redux/hooks";
import { SCartItemDto } from "@/__generated__/sdk";
import { createSelector } from '@reduxjs/toolkit';

const selectCartItems = (state:any) => state.cart?.cart?.cartItems ?? [];

export const selectCartProductItems = createSelector(
  [selectCartItems, (_, productId: string) => productId],
  (items, productId) => items.filter((i:any) => i.productId === productId)
);

export const useCart = () => 
  useAppSelector((state) => state.cart);

export const useCartHasProduct = (productId: string): boolean =>
  useAppSelector((state) =>
    Boolean(state.cart?.cart?.cartItems?.some(i => i.product.id === productId))
  );

export const useCartItem = (variantId?: number): SCartItemDto | null =>
  useAppSelector((state) => {
    if (!variantId) return null;
    return state.cart?.cart?.cartItems?.find(i => +i.variant.id === +variantId) ?? null;
  });

export const useCartProductItems = (productId: string) =>
  useAppSelector((state) => selectCartProductItems(state, productId));


export const useCartActiveVariant = (productId: string): SCartItemDto | null =>
  useAppSelector((state) =>
    state.cart?.cart?.cartItems?.find(i => i.product.id === productId) ?? null
  );

export const useCartVariant = (
  productId: string,
  variantId: number
): SCartItemDto | null =>
  useAppSelector((state) =>
    state.cart?.cart?.cartItems?.find(
      i => i.product.id === productId && i.variantId === variantId
    ) ?? null
  );

export const useCartPricingMode = () =>
  useAppSelector((state) => state.cart?.pricingMode ?? state.cart?.cart?.pricingMode ?? null);
